import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { UserType } from '../../interfaces/userType.enum';
import { usePermission } from '../../hooks/usePermission';
import { IUser } from '../../interfaces/auth.interface';

interface PermissionRouteProps {
    permissionKey?: string;
    allowedRoles: UserType[];
    alsoAllowIf?: (user: IUser | null) => boolean;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ permissionKey, allowedRoles, alsoAllowIf }) => {
    const { user } = useAuth();
    const location = useLocation();
    const userRoles = Array.isArray(user?.roles) ? (user?.roles ?? []) : [user?.roles ?? ''];
    const roleBasedFallback = allowedRoles.some(role => userRoles.includes(role));
    const permissionKeyAllowed = usePermission(permissionKey ?? '', roleBasedFallback);
    const alsoAllowed = alsoAllowIf ? alsoAllowIf(user) : false;
    const allowed = permissionKey ? (permissionKeyAllowed || alsoAllowed) : (roleBasedFallback || alsoAllowed);

    if (!user || !user.roles) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    if (!allowed) {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;
};

export default PermissionRoute;
